<template>
  <lazy-div>
    <message :messages="messages"></message>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 class="ma-0 pa-0">
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="showClmts = true">
              <v-icon>mdi-account-multiple</v-icon>
              <span style="padding-left:10px">Claimants</span>
            </v-btn>
            <v-btn @click="showDets = true">
              <v-icon>mdi-comment-text-multiple-outline</v-icon>
              <span style="padding-left:10px">Details</span>
            </v-btn>
            <v-btn @click="showAttachs = true">
              <v-icon>mdi-attachment</v-icon>
              <span style="padding-left:10px">Attachments</span>
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-toolbar color="grey darken-1" dark dense>
              <v-toolbar-title>
                <v-icon>{{claimIcon}}</v-icon>
                <span style="padding-left:10px">Claim Information</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
              <v-container fluid grid-list-lg class="mavContainer">
                <v-layout row wrap>
                  <v-flex sm3 xs6>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">Claim Submission No.</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.clmSubNo}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm3 xs6>
                    <v-flex class="ma-0 pa-0" v-if="clmSub.clmRefNo">
                      <v-subheader class="queryLabel">Claim Reference No.</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0" v-if="clmSub.clmRefNo">
                      <span class="title">{{clmSub.clmRefNo}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">Policy Holder Full Name as per NRIC / FIN / Passsport</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.insdName}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.propNo}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.propNo}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.polNo}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.polNo}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.lossDate}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{displayDate(clmSub.lossDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0" v-if="clmSub.commDate && clmSub.expDate">
                      <v-subheader class="queryLabel">Period of Cover</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title" v-if="clmSub.commDate && clmSub.expDate">{{displayDate(clmSub.commDate)}} - {{displayDate(clmSub.expDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.notDate}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{displayDate(clmSub.notDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel" v-if="clmSub.acceptDate">{{labels.acceptDate}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0" v-if="clmSub.acceptDate">
                      <span class="title">{{displayDate(clmSub.acceptDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.ackDate}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{displayDate(clmSub.ackDate)}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex/>
                  <v-flex sm6 xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.riskNo}}</span>
                    </v-flex>
                  </v-flex>
                  <v-flex/>
                  <v-flex xs12>
                    <v-flex class="ma-0 pa-0">
                      <v-subheader class="queryLabel">{{labels.cseLoss1}}</v-subheader>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.cseLoss1}}</span>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.cseLoss2}}</span>
                    </v-flex>
                    <v-flex class="ma-0 pa-0">
                      <span class="title">{{clmSub.cseLoss3}}</span>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showClmts" max-width="800px" lazy persistent>
      <claim-staging-clmts :clmSub="clmSub" @doClose="showClmts = false" />
    </v-dialog>
    <v-dialog v-model="showAttachs" max-width="800px" lazy persistent>
      <claim-staging-attachs :clmSub="clmSub" @doClose="showAttachs = false" />
    </v-dialog>
    <v-dialog v-model="showDets" max-width="800px" lazy persistent>
      <claim-staging-dets :clmSub="clmSub" @doClose="showDets = false" />
    </v-dialog>
  </lazy-div>
</template>
<script>
import { appIcon } from '@/const/underwriting'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import ClaimStagingClmts from './ClaimStagingClmts'
import ClaimStagingDets from './ClaimStagingDets'
import ClaimStagingAttachs from './ClaimStagingAttachs'
export default {
  data() {
    return {
      labels: {
        appID: 'Application Type',
        propNo: 'Proposal No.',
        polNo: 'Policy No.',
        lossDate: 'Loss Date',
        notDate: 'Notification Date',
        ackDate: 'Acknowledge Date',
        riskNo: 'Policy Benefit Section',
        acceptDate: 'Policy Acceptance Date',
        cseLoss1: 'Cause of Loss',
        cseLoss2: '',
        cseLoss3: ''
      },
      clmSub: {
        clmSubNo: undefined,
        clmRefNo: undefined,
        polNo: undefined,
        propNo: undefined,
        insdName: undefined,
        lossDate: undefined,
        status: undefined,
        createdDate: undefined,
        notDate: undefined,
        ackDate: undefined,
        riskNo: undefined,
        acceptDate: undefined,
        commDate: undefined,
        expDate: undefined,
        cseLoss1: undefined,
        cseLoss2: undefined,
        cseLoss3: undefined,
        clmtDetStgs: [],
        types: []
      },
      filtersLabel: {
        proposalNo: 'Proposal No.',
        polNo: 'Policy No.',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To'
      },
      showClmts: false,
      showDets: false,
      showAttachs: false,
      submitting: false
    }
  },
  props: [
    'id'
  ],
  mounted() {
    this.fetchData()
  },
  methods: {
    displayDate(date) {
      return formatDisplayDate(date)
    },
    async fetchData() {
      const apiUrl = this.menu.query
      try {
        const expand = {
          clmSubNo: this.id
        }
        const result = await this.$http.get(expandURI(apiUrl, expand))
        if (result.data) {
          const data = result.data
          this.clmSub = data
        }
      } catch (error) {
        this.notify(error)
      }
    }
  },
  computed: {
    claimIcon() {
      return appIcon.TRAVEL
    },
    menu() {
      return this.$store.state.claimStaging.menu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchProposalsData(false)
    },
    'pagination.page': function (value) {
      this.fetchProposalsData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchProposalsData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchProposalsData(false)
    }
  },
  components: {
    ClaimStagingClmts: ClaimStagingClmts,
    ClaimStagingAttachs: ClaimStagingAttachs,
    ClaimStagingDets: ClaimStagingDets
  },
  mixins: [
    MessageMixin,
    TableConst.default
  ]
}
</script>

<style lang="scss">
.no-line.v-text-field>.v-input__control>.v-input__slot:before, .no-line .v-input__control>.v-input__slot:before{
    border-style: none;
}
.no-line.v-text-field>.v-input__control>.v-input__slot:after,.no-line .v-input__control>.v-input__slot:after {
    border-style: none;
}
</style>
